module.exports = __webpack_public_path__ + "media/images/icons/country_flags/md-a60006c4a2acfc0b3e43efba45ee9b50.svg";